import { render, staticRenderFns } from "./ActionDueDateWidget.vue?vue&type=template&id=4351c24a&scoped=true&"
import script from "./ActionDueDateWidget.vue?vue&type=script&lang=js&"
export * from "./ActionDueDateWidget.vue?vue&type=script&lang=js&"
import style0 from "./ActionDueDateWidget.vue?vue&type=style&index=0&id=4351c24a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4351c24a",
  null
  
)

export default component.exports